/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsFeedback_seller = {
    readonly serviceId: string | null;
    readonly orderFeedbackPdp: {
        readonly totalResults: number | null;
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpSharedDealerDetailsFeedback_seller";
};
export type PdpSharedDealerDetailsFeedback_seller$data = PdpSharedDealerDetailsFeedback_seller;
export type PdpSharedDealerDetailsFeedback_seller$key = {
    readonly " $data"?: PdpSharedDealerDetailsFeedback_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsFeedback_seller">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsFeedback_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "orderFeedbackPdp",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerOrderFeedbackPdpQueryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalResults",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "SellerOrderFeedbackPdpQueryEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "OrderFeedbackPdp",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '038c509aba68e8d52d1761a1c64925ff';
export default node;
